import { faGift, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/partials/prize-image.module.scss';

const propTypes = {
    prize: AppPropTypes.prize,
    className: PropTypes.string,
};

const defaultProps = {
    prize: null,
    className: null,
};

function PrizeImage({ prize, className }) {
    const themeClassName = useThemeClassName(styles);
    const { prize: prizeObject } = prize || {};
    const { name: prizeName, image } = prizeObject || {};
    const { url: imageUrl = null, alt: imageAlt } = image || {};
    const hasImage = imageUrl !== null;

    const discount = useMemo(() => {
        const words = (prizeName || '').split(' ');
        const amounts = words.filter((word) => (word.match(/\$/g) || []).length === 1);
        const isDiscount = amounts.length === 2;
        return isDiscount ? { amount: amounts[0], required: amounts[1] } : null;
    }, [prizeName]);

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                { [className]: className !== null },
            ])}
        >
            {hasImage ? (
                <div
                    className={styles.image}
                    // style={{ backgroundImage: imageUrl !== null ? `url(${imageUrl})` : null }}
                >
                    <img src={imageUrl} alt={imageAlt} />
                </div>
            ) : (
                <div className={styles.default}>
                    {discount !== null ? (
                        <div className={styles.discount}>
                            <div className={styles.amount}>{discount.amount}</div>
                            <div className={styles.required}>
                                <div className={styles.requiredAmount}>{discount.required}</div>
                                <div className={styles.requiredIcon}>
                                    <FontAwesomeIcon icon={faShoppingCart} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.defaultIcon}>
                            <FontAwesomeIcon icon={faGift} />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

PrizeImage.propTypes = propTypes;
PrizeImage.defaultProps = defaultProps;

export default PrizeImage;
